import { h } from 'preact'
import classNames from 'clsx'

import LinkWrapper from '../../atom/link-wrapper'

import styles from './index.module.scss'

const NodeList = (props) => {
  const {
    className,
    entries = [],
    uriBuilder,
    ...rest
  } = props

  if (!entries.length) {
    return null
  }

  return (
    <ul
      {...rest}
      className={buildClassNames({ className })}
    >
      {entries.map(entry => {
        const { id } = entry

        return (
          <NodeListEntry
            {...entry}
            uriBuilder={uriBuilder}
            key={id}
          />
        )
      })}
    </ul>
  )
}

const NodeListEntry = (props) => {
  const {
    className,
    name,
    count,
    uriBuilder,
    children = [],
  } = props

  return (
    <li className={buildEntryClassNames({ className })}>
      <span>
        <LinkWrapper href={uriBuilder(props)}>{name}</LinkWrapper> ({count})
      </span>

      {children.length ? (
        <ul className={buildClassNames()}>
          {children.map(entry => {
            const { id } = entry

            return (
              <NodeListEntry
                {...entry}
                uriBuilder={uriBuilder}
                key={id}
              />
            )
          })}
        </ul>
      ) : null}
    </li>
  )
}

function buildClassNames({ className } = {}) {
  return classNames(
    className,
    styles['m-node-list'],
  )
}

function buildEntryClassNames({ className } = {}) {
  return classNames(
    className,
    styles['m-node-list__entry'],
  )
}

export default NodeList
